import api from '../api';
import { createWrapperPayload, wrapperConstants } from '../wrapper-api';

// NOTE: The precise shape of the response for /pumpchecker/Checker/Well/DashboardData
// isn't defined yet in types. Define a minimal interface; extend when backend schema is known.
export interface EspDashboardData {
  // Generic catch-all until proper type definition is known.
  // Replace with specific properties (e.g., status, metrics, timestamps, etc.).
  [key: string]: unknown;
}

/**
 * Fetch ESP Dashboard data from backend using the wrapper router.
 * Returns the raw response data (or throws on network error).
 */
export const fetchEspDashboardDataService = async (params?: {
  areaIds?: string[];
  businessUnitIds?: string[];
  fieldIds?: string[];
  wellIds?: string[] | string;
}): Promise<any> => {
  const requestPayload = createWrapperPayload(
    'GET',
    '/pumpchecker/Checker/Well/DashboardData',
    undefined,
    false,
    params?.areaIds,
    params?.businessUnitIds,
    params?.fieldIds,
    params?.wellIds,
  );
  const resp = await api.post(wrapperConstants.router, requestPayload);
  return resp?.data ?? undefined;
};
